import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupErrorView',
  emits: ["close"],
  setup(__props, { emit }) {

const active = ref(true);


const close = () => {
  active.value = false;
  emit("close", false);
};

return { __sfc: true,active, emit, close }
}

})